import React, { useCallback, useEffect, useState } from 'react';
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  const [hasReachedPain, setHasReachedPain] = useState(false);
  const [bounceIn, setBounceIn] = useState(false);
  useEffect(() => {
    // Show button after a short delay with bounce
    const timer = setTimeout(() => {
      setVisible(true);
      setBounceIn(true);
      // Remove bounce class after animation
      setTimeout(() => setBounceIn(false), 800);
    }, 1500);
    return () => clearTimeout(timer);
  }, []);
  useEffect(() => {
    const onScroll = () => {
      const painSection = document.getElementById('pain-section');
      if (painSection) {
        const rect = painSection.getBoundingClientRect();
        // Hide when pain section is visible in viewport
        if (rect.top <= window.innerHeight * 0.8) {
          setHasReachedPain(true);
        } else {
          setHasReachedPain(false);
        }
      }
    };
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const handleClick = useCallback(() => {
    const painSection = document.getElementById('pain-section');
    if (painSection) {
      painSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }, []);
  const shouldShow = visible && !hasReachedPain;
  return <button onClick={handleClick} className={`${`
        fixed bottom-4 left-1/2 -translate-x-1/2 z-[9999]
        max-w-[90%] w-auto
        px-5 py-3.5
        bg-[#FFD84D] text-black font-bold
        rounded-xl
        transition-all duration-500 ease-out
        md:hidden
        ${shouldShow ? 'translate-y-0 opacity-100' : 'translate-y-24 opacity-0 pointer-events-none'}
        ${bounceIn ? 'floating-cta-bounce' : ''}
        floating-cta-pulse
      `} text-[14px]`} style={{
    boxShadow: '0px 6px 20px rgba(0,0,0,0.15)',
    lineHeight: '1.3'
  }} aria-label="Ver por qué sigues fallando - ir a sección" data-id="element-92">
      👇 Evita que tu azúcar se dispare otra vez
    </button>;
}